module.exports = __webpack_public_path__ + "img/wz-8-6-3.84ce453d.jpg";